/**
 * @function runJS
 * @memberof Promega.Util
 * @description Constructs a function from a string of JavaScript and immediately invokes it.
 * @param {String} js A string of valid JavaScript to execute
 */
export default function runJS (js) {
    var tmp = new Function('"use strict"; ' + js);
    tmp();          
}
